// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-Greeting-module--cls1--1bwRA","cls2":"index-Greeting-module--cls2--tRwVx index-Greeting-module--cls1--1bwRA"};